import { render, staticRenderFns } from "./ListComponentV3.vue?vue&type=template&id=3db8be33&"
import script from "./ListComponentV3.vue?vue&type=script&lang=ts&"
export * from "./ListComponentV3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports